import * as API from '@/services/API';

export default {
  list({ commit, dispatch }, opportunityId) {
    return API.apiClient
      .get('/opportunities/' + opportunityId + '/tasks')
      .then((response) => {
        commit('SET_TASK_LIST', response.data);
        return response.data;
      })
      .catch((error) => {
        commit('SET_ERROR', error, { root: true });
      });
  },

  add({ commit, dispatch }, [opportunityId, task]) {
    return API.apiClient
      .post('/opportunities/' + opportunityId + '/tasks', task)
      .then((response) => {
        return dispatch('list', opportunityId);
      })
      .catch((error) => {
        commit('SET_ERROR', error, { root: true });
      });
  },
  delete({ commit, dispatch }, [opportunityId, taskId]) {
    return API.apiClient
      .delete('/opportunities/' + opportunityId + '/tasks/' + taskId)
      .then((response) => {
        return dispatch('list', opportunityId);
      })
      .catch((error) => {
        commit('SET_ERROR', error, { root: true });
      });
  },
  update({ commit, dispatch }, [opportunityId, task]) {
    return API.apiClient
      .put('/opportunities/' + opportunityId + '/tasks/' + task.id, task)
      .then((response) => {
        //return dispatch('list', opportunityId)
      })
      .catch((error) => {
        commit('SET_ERROR', error, { root: true });
      });
  },
  updateTaskList({ commit, state, dispatch }, payload) {
    for (let index = 0; index < payload.length; index++) {
      payload[index].order = index;
      API.apiClient.put(
        '/opportunities/' + payload[index].opportunity_id + '/tasks/' + payload[index].id,
        payload[index]
      );
    }
    return dispatch('list', payload[0].opportunity_id);
  },
};
